// extracted by mini-css-extract-plugin
module.exports = {"pane":"MobilePane_pane__CUVvX","visible":"MobilePane_visible__i2FD5"};